import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const LinkedInCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasRun = useRef(false); // 👈 prevents double execution

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const code = new URLSearchParams(window.location.search).get("code");

    if (!code) {
      console.error("❌ No 'code' found in LinkedIn redirect.");
      return;
    }

    console.log("✅ LinkedIn code received:", code);

    const exchangeToken = async () => {
      try {
        const exchangeUrl = process.env.REACT_APP_LINKEDIN_EXCHANGE;
        console.log("🔁 Exchanging code at:", exchangeUrl);

        const { data } = await axios.post(exchangeUrl, { code });
        console.log("📦 LinkedIn token exchange response:", data);

        const { accessToken, profile, platformUser } = data;
        if (!accessToken || !profile) {
          throw new Error("❌ Missing access token or profile from backend.");
        }

        console.log("🔑 Access token received:", accessToken);
        console.log("👤 LinkedIn profile received:", profile);
        console.log("🏛️ Platform user data received:", platformUser);

        login({
          accessToken,
          linkedInId: profile.sub,
          name: profile.name || `${profile.given_name} ${profile.family_name}`.trim(),
          givenName: profile.given_name,
          familyName: profile.family_name,
          email: profile.email,
          picture: profile.picture,
          locale: profile.locale,
          platformUser, // 👈 includes isAdmin, isDeveloper, roles, etc.
        });

        console.log("✅ User logged in successfully:", profile.name);
        navigate("/");
      } catch (err) {
        console.error(
          "🔥 LinkedIn login failed:",
          err.response?.data || err.message
        );
        alert("LinkedIn login failed. Check console for details.");
      }
    };

    exchangeToken();
  }, [navigate, login]);

  return <p>Logging in via LinkedIn...</p>;
};

export default LinkedInCallback;
